export const directSwitchSessionStatus = {
  NONE: 0,
  READY: 1, // ready to process a direct switch request
  ERRORED: 2, // direct switch request has errored
  COMPLETED_SUCCESSFULLY: 3, // direct switch request has completed with a valid offer
  COMPLETED_WITH_ERROR: 4, // direct switch request has completed with error,
  COMPLETED_COMPARISON: 5 // direct switch request has completed to a comparison
};
